// Toggling the row to allow extend gear cover
$("#toggleAmendCover").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("extend-cover-visible");
});